module.exports = __webpack_public_path__ + "img/pr-8.43ce757d.png";